<template>
    <carousel
            class=""
            :autoplay="false"
            :nav="false"
            :autoWidth="false"
            :dots="false"
            :loop="true"
    >
        <v-img
                v-for="often in chipsData" :key="often.systemName"
                class="mx-3"
        >
            <v-chip
                    color="teal"
                    outlined
                    link
            >
                <router-link :to="often.path" class="black--text body-2">{{often.localName}}</router-link>
            </v-chip>
        </v-img>
    </carousel>
</template>

<script>
    import carousel from 'vue-owl-carousel';

    export default {
        name: "CategoriesChips",
        props:['chipsData'],
        components:{carousel}
    }
</script>

<style scoped>

</style>
